/**
 * Navigation « formation » côté apprenant (réutilisé : tunnel SCORM, dashboard).
 */

/** Page synthèse d'une formation (même destination que le clic sur une carte). */
export function courseDashboardPath(courseId: string): string {
  return `/course/${courseId}`;
}

/**
 * Après auth SCORM : une formation ciblée → son dashboard ; sinon liste des formations.
 */
export function courseDashboardPathOrHome(formationId?: string | null): string {
  if (formationId) return courseDashboardPath(formationId);
  return '/';
}

/**
 * Si l’apprenant n’a qu’une seule formation inscrite, chemin vers son dashboard.
 * Sinon `null` (afficher la liste).
 */
export function singleEnrolledCoursePath(
  courses: Array<{ id?: string; _id?: unknown }> | null | undefined
): string | null {
  if (!courses || courses.length !== 1) return null;
  const raw = courses[0].id ?? courses[0]._id;
  if (raw === undefined || raw === null) return null;
  const id = String(raw).trim();
  if (!id) return null;
  return courseDashboardPath(id);
}
